<template>
  <section class="log-system-index-container">
    <base-header
      v-bind="headers"
    />
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
      @handleBtnSearch='handleEventBtnSearch'
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleSelectionChange="handleSelectionChange"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
    </base-table>
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseTable from '@/components/mixins/baseTable'
import msgDialog from '@/components/mixins/msgDialog'
import searchHeader from '@/components/mixins/searchHeader'

const columns = [
  {
    prop: 'title',
    label: '稿件名称'
  },
  {
    prop: 'createUser',
    label: '投稿人'
  },
  {
    prop: 'status',
    label: '状态',
    formatter: (row, column, cellValue, index) => {
      const options = [
        {
          label: '草稿',
          value: 'DRAFT'
        },
        {
          label: '待审核',
          value: 'UNCHECK'
        },
        {
          label: '审核中',
          value: 'CHECKING'
        },
        {
          label: '已撤稿',
          value: 'CANCEL'
        },
        {
          label: '已返修',
          value: 'REFUND'
        },
        {
          label: '已录用',
          value: 'SUCCESS'
        },
        {
          label: '被退稿',
          value: 'CANCELED'
        },
        {
          label: '系统退稿',
          value: 'SYSTEM_CANCELED'
        },
        {
          label: '申请撤稿',
          value: 'CHECK_CANCEL'
        },
        {
          label: '专家审核中',
          value: 'CHECKING_PROFESSOR'
        }
      ]
      const opt = options.find(d => d.value === cellValue)
      return opt ? opt.label : ''
    }
  },
  {
    scopeType: 'time',
    prop: 'createTime',
    label: '创建时间',
    minWidth: '150px'
  }
]
export default {
  name: 'listIndex',
  mixins: [baseHeader, baseTable, searchHeader, msgDialog],
  data () {
    return {
      searchHeader: {
        searchItems: [
          {
            type: 'input',
            value: 'queryTitle',
            label: '标题：',
            placeholder: '请输入标题',
            style: {
              width: '220px'
            }
          },
          {
            type: 'input',
            value: 'queryCreateUser',
            label: '投稿人：',
            placeholder: '请输入投稿人',
            style: {
              width: '220px'
            }
          },
          {
            type: 'select',
            value: 'queryStatus',
            label: '状态：',
            placeholder: '请选择状态',
            options: [
              {
                value: '',
                label: '所有'
              },
              {
                label: '草稿',
                value: 'DRAFT'
              },
              {
                label: '待审核',
                value: 'UNCHECK'
              },
              {
                label: '审核中',
                value: 'CHECKING'
              },
              {
                label: '已撤稿',
                value: 'CANCEL'
              },
              {
                label: '已返修',
                value: 'REFUND'
              },
              {
                label: '已录用',
                value: 'SUCCESS'
              },
              {
                label: '被退稿',
                value: 'CANCELED'
              },
              {
                label: '系统退稿',
                value: 'SYSTEM_CANCELED'
              },
              {
                label: '申请撤稿',
                value: 'CHECK_CANCEL'
              },
              {
                label: '专家审核中',
                value: 'CHECKING_PROFESSOR'
              }
            ]
          },
          {
            type: 'checked',
            value: 'queryOnlyMe',
            label: '仅展示转给我的'
          },
          {
            type: 'timePicker',
            value: 'time',
            label: '创建时间：',
            rangeText: '-'
          },
          {
            btnType: 'Search',
            type: 'henderBorderBtn',
            text: '搜索',
            icon: 'xiazai15'
          }
        ]
      },
      list: {
        columns,
        api: 'fetchExtcontentList',
        params: {
          queryTitle: '',
          queryCreateUser: '',
          queryStatus: '',
          queryOnlyMe: false
        },
        handleColumn: [
          {
            type: 'Link',
            name: '审核',
            icon: 'chongmingming',
            // notDisabled: true,
            href: '/extcontent/list/check'
          },
          {
            type: 'Link',
            name: '查看',
            icon: 'chakan',
            notDisabled: true,
            href: '/extcontent/list/detail'
          }
        ],
        handleColumnProp: {
          label: '操作',
          width: '300',
          align: 'left'
        },
        showSelection: false
      },
      headers: {
        buttons: [],
        title: '内容列表',
        showAlertIcon: false,
        content: ''
      }
    }
  },
  components: {
  },
  methods: {
    // 搜索
    handleSearchs () {
      var params = this.list.params
      if (params.time) {
        params.queryCreateTimeStart = params.time[0]
        params.queryCreateTimeEnd = params.time[1]
      } else {
        params.queryCreateTimeStart = ''
        params.queryCreateTimeEnd = ''
      }
      this.list.params = params
      this.fetchTableApi()
    },
    handleEventBtnSearch () {
      this.handleSearchs()
    },
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content
        this.list.data = res.data.content.map((d, i) => {
          d.disabled = !(d.status === 'UNCHECK' || d.status === 'CHECKING' || d.status === 'CHECK_CANCEL')
          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
